import * as Types from '../../../__generated__/schema';

import { UserTeaser } from './UserTeaser.generated';
import { APITokenTeaser } from './APITokenTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type ActorTeaserAPIToken = APITokenTeaser;

export type ActorTeaserUser = UserTeaser;

export type ActorTeaser = ActorTeaserAPIToken | ActorTeaserUser;

export const ActorTeaser = gql`
  fragment ActorTeaser on Actor {
    ... on User {
      ...UserTeaser
    }
    ... on APIToken {
      ...APITokenTeaser
    }
  }
  ${UserTeaser}
  ${APITokenTeaser}
`;
